import { Navigate, RouteObject } from 'react-router-dom';
import LazyErrorPage from '../components/error-page/lazy-error-page';
import LazyPrivacyPolicy from '../components/legal-views/lazy-privacy-policy';
import LazyTermsAndConditions from '../components/legal-views/lazy-terms-and-conditions';
import LazySignIn from '../components/main-container/sign-in/lazy-sign-in';
import LazyHubSpotOAuthCallbackPage from '../components/hubspot-oauth-callback-page/lazy-hubspot-oauth-callback-page';
import LazyXeroOAuthCallbackPage from '../components/xero-oauth-callback-page/lazy-xero-oauth-callback-page';
import AppRoutes from '../enums/app-routes';
import UnprotectedRoute from './unprotected-route.tsx/unprotected-route';

const publicRoutes: RouteObject[] = [
	{
		path: AppRoutes.Login,
		element: (
			<UnprotectedRoute>
				<LazySignIn />
			</UnprotectedRoute>
		),
		errorElement: <LazyErrorPage />,
	},
	{
		path: AppRoutes.PrivacyPolicy,
		element: <LazyPrivacyPolicy />,
	},
	{
		path: AppRoutes.TermsAndConditions,
		element: <LazyTermsAndConditions />,
	},
	{
		path: AppRoutes.XeroOAuthCallback,
		element: <LazyXeroOAuthCallbackPage />,
	},
	{
		path: AppRoutes.HubSpotOAuthCallback,
		element: <LazyHubSpotOAuthCallbackPage />,
	},
	/* Disabled signup until further notice */
	// {
	// 	path: AppRoutes.SignUp,
	// 	element: (
	// 		<UnprotectedRoute>
	// 			<LazySignUp />
	// 		</UnprotectedRoute>
	// 	),
	// },
	// {
	// 	path: AppRoutes.ForgotPassword,
	// 	element: (
	// 		<UnprotectedRoute>
	// 			<LazyForgotPassword />
	// 		</UnprotectedRoute>
	// 	),
	// },
	{
		path: '*',
		element: <Navigate to={AppRoutes.Root} replace={true} />,
	},
];

export default publicRoutes;
